import AbstractRepository from "@/repositories/AbstractRepository";

export default class TopicRepository extends AbstractRepository {
    protected static resource: string = "ptf-topic";

    protected static defaultFields: string[] = [
        "uuid",
        "title",
        "archivedAt",
        "parent.uuid",
        "wishes.uuid",
        "wishes.label",
        "minAmount",
        "scopeOwner.uuid",
    ];
}
